import { GeoPosicaoModel } from './GeoPosicaoModel';
import EstadoModel from '../Estados';
import TipoEndereco from '../TipoEndereco';

export default class LocalidadeModel {
    id?: number;
    logradouro!: string;
    numero!: string;
    complemento!: string;
    bairro!: string;
    cidade!: string;
    estado?: EstadoModel;
    informarEnderecoManual!: boolean;
    cep?: string;
    tipoEndereco?: TipoEndereco;
    geoPosicao?: GeoPosicaoModel;
    latitude?: number;
    longitude?: number;
    nomeResponsavel?: string;
    telefoneResponsavel?: string;
    
    get enderecoCompleto(): string {
        if (!this.informarEnderecoManual) {
            let enderecoCompleto = "";
            if (this.logradouro) {
                enderecoCompleto += this.logradouro + ", ";
            }
            if (this.numero) {
                enderecoCompleto += this.numero + ", ";
            }
            if (this.complemento) {
                enderecoCompleto += this.complemento + ", ";
            }
            if (this.bairro) {
                enderecoCompleto += this.bairro + ", ";
            }
            if (this.cidade) {
                enderecoCompleto += this.cidade + ", ";
            }
            if (this.estado) {
                enderecoCompleto += this.estado.nome;
            }

            return enderecoCompleto;
        } else {
            return `O endereço desejado não está na lista`;
        }
    }

}